import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Button, DatePicker, Dropdown, Menu, Modal, Spin, Typography } from "antd";
import QueueAnim from "rc-queue-anim";
import enquire from "enquire.js";

import moment from "moment";

import { DESKTOP_DOWN } from "../../config/mediaQueries";

import { generalActions } from "./../../redux/actions";

import { partialJustificationsService } from "./../../redux/services";

import {
	UIPageListing,
} from "./../../components";

import { statusKpis } from "./../../components/KpiCards";

import { formatHours } from "./../../helpers/hours";

import ModalShow from "./show";
import ModalFilters from "./filters";
import ModalEdit from "./edit";
import ModalCreate from "./create";

const config = {
	title            : "Justificativa Parcial",
	subtitle         : "Visualize e gerencie as justificativas parciais registradas.",
	icon             : <i className="fal fa-clipboard-list" />,
	permissionPrefix : "justificativa-parcial",
	list             : "justificativa-parcial",
	searchPlaceholder: "Buscar por data",
	orders           : [
		{
			label  : "Data (Mais recentes)",
			field  : "data",
			sort   : "desc",
			default: true,
		},
		{
			label: "Data (Mais antigos)",
			field: "data",
			sort : "asc",
		},
		{
			label: "Cadastro (Mais recentes)",
			field: "id",
			sort : "desc",
		},
		{
			label: "Cadastro (Mais antigos)",
			field: "id",
			sort : "asc",
		},
	],
};

class Index extends Component {
	constructor(props) {
		super(props);

		const defaultOrder = config.orders.find(o => o.default);

		this.state = {
			isLoading   : false,
			listType    : "list",
			data        : [],
			pagination  : {
				current : 1,
				pageSize: 20,
				total   : 0,
			},
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
			search      : "",
			// Actions
			editModalVisible    : false,
			showModalVisible    : false,
			exportModalVisible  : false,
			filtersModalVisible : false,
			activeLoadings      : [],
			isExporting         : false,
			passwordModalVisible: false,
			// Images
			imagePreviewVisible: false,
			imagePreviewImage  : "",
			// Media queries
			desktopDown: false,
			// Filters
			filters     : {
				empresa: null,
				justificativa: null,
				departamento: null,
				funcionario: null,
				status     : 1,
				created_at: null,
			},
			periodo: null,
			kpis   : null,
		};
	}

	static getDerivedStateFromProps(props, state) {
		if( props.listType && state.listType !== props.listType )
		{
			return {
				listType: props.listType
			};
		}

		return null;
	}

	componentDidMount() {
		// Fecth all
		this.fetchGetAll(true);

		// Listen Media Querie sideBar
		enquire.register(DESKTOP_DOWN, {
			match  : () => {
				this.setState({
					desktopDown: true,
				})
			},
			unmatch: () => {
				this.setState({
					desktopDown: false,
				})
			}
		});
	};

	componentWillUnmount() {
		// Unlisten Media Querie sideBar
		enquire.unregister(DESKTOP_DOWN);
	};

	menuItem = (item) => (
		<Menu className="actions-dropdown-menu">
			{this.props.permissions.includes(config.permissionPrefix + ".show") && <Menu.Item key="show">
				<a onClick={() => this.showOpen(item)}>
					<i className="fal fa-file" />Visualizar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".edit") && <Menu.Item key="edit">
				<a onClick={() => this.editOpen(item)}>
					<i className="fal fa-pen" />Editar
				</a>
			</Menu.Item>}
			{this.props.permissions.includes(config.permissionPrefix + ".delete") && <Menu.Item key="delete" className="divider btn-delete">
				<a onClick={() => this.deleteConfirm(item)}>
					<i className="fal fa-trash" />Excluir
				</a>
			</Menu.Item>}
		</Menu>
	);

	renderNames = (items, emptyLabel) => {
		const names = (items ?? []).map((item) => item.nome).join(", ");

		return names ? <Typography.Text ellipsis={{ tooltip: names }}>{names}</Typography.Text> : emptyLabel;
	};

	columns = () => {
		const listTypeCard = this.state.listType === "card";
		return [
			{
				title: "Data",
				className: "datetime card-block-width-2",
				render: (item) => {
					if (listTypeCard) {
						return (
							<Fragment>
								<i className="fal fa-calendar-alt" style={{ marginRight: 5 }} />{moment(item.data).format("DD/MM/YYYY")}
							</Fragment>
						);
					}

					return moment(item.data).format("DD/MM/YYYY");
				}
			},
			{
				title: "Horário início",
				className: "datetime card-block-width-2",
				render: (item) => {
					if (listTypeCard) {
						return (
							<Fragment>
								<i className="fal fa-sign-in-alt" style={{ marginRight: 5 }} />{item.hora_inicio}
							</Fragment>
						);
					}

					return item.hora_inicio;
				}
			},
			{
				title: "Horário fim",
				className: "datetime card-block-width-2",
				render: (item) => {
					if (listTypeCard) {
						return (
							<Fragment>
								<i className="fal fa-sign-out-alt" style={{ marginRight: 5 }} />{item.hora_fim}
							</Fragment>
						);
					}

					return item.hora_fim;
				}
			},
			{
				title : "Justificativa",
				render: (item) => listTypeCard ? <h3>{item.justificativa ? item.justificativa.nome : "Todas"}</h3> : (item.justificativa ? item.justificativa.nome : "Todas"),
			},
			{
				title : "Empresa",
				render: (item) => this.renderNames(item.empresas, "Todas"),
			},
			{
				title : "Departamento",
				render: (item) => this.renderNames(item.departamentos, "Todos"),
			},
			{
				title : "Funcionário",
				render: (item) => this.renderNames(item.funcionarios, "Todos"),
			},
			{
				title    : "Status",
				className: "active no-ellipsis",
				width    : 90,
				render   : (item) => this.state.activeLoadings.indexOf(item.uuid) !== -1 ? <Spin indicator={<i className="fad fa-spinner-third fa-spin" />} /> : (
					<span className={`status-tag ${item.status ? "status-tag-success" : "status-tag-error"}`}>
						<i className="status-tag-dot" />
						{item.status ? "Ativo" : "Inativo"}
					</span>
				)
			},
			{
				title    : "Ações",
				className: "actions no-ellipsis",
				visible  : this.props.permissions.includes(config.permissionPrefix + ".show") || this.props.permissions.includes(config.permissionPrefix + ".edit") || this.props.permissions.includes(config.permissionPrefix + ".delete"),
				render   : (item) => (
					<Dropdown overlay={this.menuItem(item)} className="actions-dropdown" placement="bottomRight" trigger={["click"]}>
						<Button icon={<i className="fal fa-ellipsis-v" />} />
					</Dropdown>
				),
			},
		];
	};

	fetchGetAll = (init = false, exportItems = false) => {
		const {pagination, orderByField, orderBySort, search, filters, periodo} = this.state;
		if( exportItems )
		{
			this.setState({
				isExporting: true,
			});
		}
		else
		{
			this.setState({
				isLoading: true,
			});
		}

		const data = {
			orderBy: `${orderByField}:${orderBySort}`,
			search : search,
		};

		if( exportItems )
		{
			data.exportItems = true;
		}
		else
		{
			data.page  = init ? 1 : pagination.current;
			data.limit = pagination.pageSize;
		}

		if( filters.status !== null )
		{
			data.status = filters.status;
		}

		if( filters.empresa !== null )
		{
			data.empresa = filters.empresa;
		}

		if( filters.funcionario !== null )
		{
			data.funcionario = filters.funcionario;
		}

		if( filters.justificativa !== null )
		{
			data.justificativa = filters.justificativa;
		}

		if( filters.departamento !== null )
		{
			data.departamento = filters.departamento;
		}

		if( periodo?.[0] )
		{
			data.data_inicio = periodo[0].format("YYYY-MM-DD");
		}

		if( periodo?.[1] )
		{
			data.data_fim = periodo[1].format("YYYY-MM-DD");
		}

		if( filters.created_at )
		{
			data.created_at = [
				filters.created_at[0].clone().startOf("day").format("YYYY-MM-DDTHH:mm:ssZ"),
				filters.created_at[1].clone().endOf("day").format("YYYY-MM-DDTHH:mm:ssZ")
			];
		}

		partialJustificationsService.getAll(data)
		.then((response) => {
			if( exportItems )
			{	
				this.setState({
					isExporting: false,
				});

				window.open(response.data.file_url, "_blank");
			}
			else
			{
				this.setState(state => ({
					isLoading : false,
					data      : response.data.data,
					kpis      : response.data.kpis ?? null,
					pagination: {
						...state.pagination,
						current: response.data.meta.current_page,
						total  : response.data.meta.total,
					},
				}));
			}
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	onPeriodoChange = (periodo) => {
		this.setState({ periodo }, () => this.fetchGetAll(true));
	};

	kpis = () => {
		const { kpis, filters } = this.state;

		return [
			{
				key    : "horas",
				tone   : "blue",
				icon   : <i className="fal fa-clock" />,
				title  : "Horas justificadas no período",
				value  : kpis ? formatHours(kpis.minutos_justificados) : null,
				caption: kpis ? `Total de ${kpis.registros} ${kpis.registros === 1 ? "registro" : "registros"}` : null,
			},
			{
				key    : "media",
				tone   : "green",
				icon   : <i className="fal fa-chart-line" />,
				title  : "Média por justificativa",
				value  : kpis ? formatHours(kpis.media_minutos) : null,
				caption: "Nos registros listados",
			},
			...statusKpis({
				kpis,
				icon          : <i className="fal fa-file-alt" />,
				title         : "Total de justificativas",
				caption       : "Justificativas cadastradas",
				status        : filters.status,
				onStatusChange: this.onStatusKpiChange,
			}),
		];
	};

	onStatusKpiChange = (status) => {
		this.setState(state => ({
			filters: {
				...state.filters,
				status,
			},
		}), () => this.fetchGetAll(true));
	};

	onListTypeChange = (type) => {
		this.props.onChangeListType(type);
	};

	onPaginationChange = (page, pageSize) => {
		this.setState(state => ({
			pagination: {
				...state.pagination,
				current: page,
				pageSize,
			},
		}), () => {
			this.fetchGetAll();
		});
	};

	onOrderChange = (value) => {
		const defaultOrder = config.orders.find(o => `${o.field}:${o.sort}` === value);

		if( !defaultOrder ) return null;

		this.setState(state => ({
			orderByLabel: defaultOrder.label,
			orderByField: defaultOrder.field,
			orderBySort : defaultOrder.sort,
		}), () => {
			this.fetchGetAll(true);
		});
	};

	onSearch = (value) => {
		this.setState({
			search: value,
		}, () => {
			this.fetchGetAll(true);
		});
	};

	onSearchChange = (e) => {
		// If it does not have type then it's cleaning
		if( !e.hasOwnProperty("type") )
		{
			const {search} = this.state;

			this.setState({
				search: e.target.value,
			}, () => {
				if( search )
				{
					this.fetchGetAll(true);
				}
			});
		}
	};

	/**
	 * Show
	 *
	 * @param uuid
	 */
	showOpen = ({uuid}, general_key) => {
		this.setState({showModalVisible: true});

		// On open screen
		this.showScreen.onOpen(uuid, general_key);
	};

	showOnClose = () => {
		this.setState({showModalVisible: false});
	};

	/**
	 * Delete
	 *
	 * @param uuid
	 */
	deleteConfirm = ({uuid}) => {
		Modal.confirm({
			title          : "Confirmar exclusão!",
			content        : "Tem certeza de que deseja excluir este registro?",
			okText         : "Excluir",
			autoFocusButton: null,
			onOk           : () => {
				return this.deleteConfirmed(uuid);
			}
		});
	};

	deleteConfirmed = (uuid) => {
		return partialJustificationsService.destroy({uuid})
		.then((response) => {
			// Fecth all
			this.fetchGetAll();
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		});
	};

	/**
	 * Create
	 */
	createOpen = () => {
		this.setState({createModalVisible: true});

		// On open screen
		this.createScreen.onOpen();
	};

	createOnClose = () => {
		this.setState({createModalVisible: false});
	};

	createOnComplete = () => {
		this.setState({createModalVisible: false});
		// Fecth all
		this.fetchGetAll(true);
		
		// setTimeout(() => {
		// 	this.showOpen(this.state.data[0]);
		// }, 1000);
	};

	/**
	 * Edit
	 *
	 * @param uuid
	 */
	editOpen = ({uuid}) => {
		this.setState({editModalVisible: true});

		// On open screen
		this.editScreen.onOpen(uuid);
	};

	editOnClose = () => {
		this.setState({editModalVisible: false});
	};

	editOnComplete = () => {
		this.setState({editModalVisible: false});

		// Fecth all
		this.fetchGetAll();
	};

	/**
	 * Password
	 */
	passwordOpen = (item) => {
		this.setState({passwordModalVisible: true});

		// On open screen
		this.passwordScreen.onOpen(item);
	};

	passwordOnClose = () => {
		this.setState({passwordModalVisible: false});
	};

	passwordOnComplete = () => {
		this.setState({passwordModalVisible: false});

		Modal.success({
			title  : "E-mail enviado!",
			content: "Foi enviado para o usuário sua nova senha.",
		});
	};

	/**
	 * Filter
	 */
	filtersOpen = () => {
		this.setState({filtersModalVisible: true});

		// On open screen
		this.filtersScreen.onOpen({...this.state.filters});
	};

	filtersOnClose = () => {
		this.setState({filtersModalVisible: false});
	};

	filtersOnComplete = (filters) => {
		this.setState({filtersModalVisible: false});
		this.setState({
			filters: filters,
		}, () => {
			// Fecth all
			this.fetchGetAll(true);
		});
	};

	/**
	 * Active/Desactive
	 *
	 * @param {number} uuid
	 * @param {boolean} activate
	 */
	activateDeactivate = ({uuid}, activate) => {
		const {activeLoadings} = this.state;

		if( activeLoadings.indexOf(uuid) === -1 )
		{
			activeLoadings.push(uuid);
		}

		this.setState({
			activeLoadings: activeLoadings,
		});

		partialJustificationsService.edit({uuid, ativo: activate})
		.then((response) => {
			const newData = [...this.state.data];
			const index   = newData.findIndex(item => uuid === item.uuid);

			if( index !== -1 )
			{
				const item = newData[index];

				newData.splice(index, 1, {
					...item,
					status: response.data.data.status,
				});

				this.setState({
					data: newData,
				});
			}
		})
		.catch((data) => {
			Modal.error({
				title  : "Ocorreu um erro!",
				content: String(data),
			});
		}).finally(() => {
			const {activeLoadings} = this.state;
			const index            = activeLoadings.indexOf(uuid);

			if( index !== -1 )
			{
				activeLoadings.splice(index, 1);

				this.setState({
					activeLoadings: activeLoadings,
				});
			}
		});
	};

	/**
	 * Image preview
	 */
	onImagePreviewClose = () => this.setState({imagePreviewVisible: false});

	onImagePreview = (url) => {
		this.setState({
			imagePreviewImage  : url,
			imagePreviewVisible: true,
		});
	};

	filtersCount = () => {
		const { empresa, justificativa, departamento, funcionario, created_at } = this.state.filters;

		return [empresa, justificativa, departamento, funcionario, created_at].filter(Boolean).length;
	};

	render() {
		return (
			<QueueAnim className="site-content-inner">
				<div className="page-content fixed-header partial-justifications-page" key="1">
					<UIPageListing
						icon={config.icon}
						title={config.title}
						subtitle={config.subtitle}
						kpis={this.kpis()}
						appendSearch={(
							<DatePicker.RangePicker
								size="large"
								format="DD/MM/YYYY"
								placeholder={["Data início", "Data fim"]}
								allowEmpty={[true, true]}
								value={this.state.periodo}
								onChange={this.onPeriodoChange}
							/>
						)}
						filtersCount={this.filtersCount()}
						onPaginationChange={this.onPaginationChange}
						onOrderChange={this.onOrderChange}
						onListTypeChange={this.onListTypeChange}
						onFiltersClick={this.filtersOpen}
						isLoading={this.state.isLoading}
						enableSearch={false}
						listType={this.state.listType}
						orderByField={this.state.orderByField}
						orderBySort={this.state.orderBySort}
						orders={config.orders}
						search={this.state.search}
						searchPlaceholder={config.searchPlaceholder}
						data={this.state.data}
						pagination={this.state.pagination}
						columns={this.columns()}
						showFilters={true}
						buttons={[
							{
								visible: this.props.permissions.includes(config.permissionPrefix + ".create"),
								onClick: this.createOpen,
								title  : "Incluir",
								icon   : <i className="far fa-plus" />,
							},
							{
								visible: false , // TODO this.props.permissions.includes(config.permissionPrefix + ".export"),
								onClick: () => this.fetchGetAll(true, true),
								title  : this.state.isExporting ? "Exportando" : "Exportar",
								icon   : <i className="fal fa-file-export" />,
								loading: this.state.isExporting,
							},
						]}
					/>
				</div>
				<ModalCreate
					ref={el => this.createScreen = el}
					visible={this.state.createModalVisible}
					onComplete={this.createOnComplete}
					onClose={this.createOnClose}
				/>
				<ModalEdit
					ref={el => this.editScreen = el}
					visible={this.state.editModalVisible}
					onComplete={this.editOnComplete}
					onClose={this.editOnClose}
				/>
				<ModalShow
					ref={el => this.showScreen = el}
					visible={this.state.showModalVisible}
					onClose={this.showOnClose}
				/>
				<ModalFilters
					ref={el => this.filtersScreen = el}
					visible={this.state.filtersModalVisible}
					onComplete={this.filtersOnComplete}
					onClose={this.filtersOnClose}
				/>
				<Modal wrapClassName="modal-image" visible={this.state.imagePreviewVisible} centered footer={null} destroyOnClose={true} onCancel={this.onImagePreviewClose}>
					<img src={this.state.imagePreviewImage} />
				</Modal>
			</QueueAnim>
		)
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		permissions: state.auth.userData.permissions,
		listType   : state.general.listType[config.list],
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		onChangeListType: (type) => {
			dispatch(generalActions.changeListType(config.list, type));
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
